import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import './HeaderIcon.css';

function findLinkSource(link) {
  if (link) {
    if (link.includes('google')) return {
      name: 'google plus',
      style: {
        color: '#DD4B39'
      }
    };
    if (link.includes('facebook')) return {
      name: 'facebook',
      style: {
        color: '#3b5998'
      }
    };
    if (link.includes('yelp')) return {
      name: 'yelp',
      style: {
        color: '#c41200'
      }
    };
    if (link.includes('tripadvisor')) return {
      name: 'tripadvisor',
      style: {
        color: '#00af87'
      }
    };
  }

  return {
    name: '',
    style: {}
  };
}

function renderIcon(iconProps) {
  var name = iconProps.name,
      style = iconProps.style;
  return /*#__PURE__*/React.createElement(Icon, {
    name: name,
    style: style,
    size: "small"
  });
}

var HeaderIcon = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(HeaderIcon, _React$PureComponent);

  function HeaderIcon() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = HeaderIcon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        link = _this$props.link,
        showLink = _this$props.showLink,
        isVerticalItem = _this$props.isVerticalItem;
    var iconProps = findLinkSource(link); // For verticalItems we need to override the default <Header.Content /> CSS in ItemElement

    if (isVerticalItem) {
      iconProps.style = _extends({}, iconProps.style, {
        display: 'inline-block',
        fontSize: '1em'
      });
    }

    var icon = renderIcon(iconProps);
    return link && showLink ? /*#__PURE__*/React.createElement("a", {
      href: link,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "header-icon",
      "aria-label": iconProps.name
    }, icon)) : icon;
  };

  return HeaderIcon;
}(React.PureComponent);

export { HeaderIcon as default };
HeaderIcon.defaultProps = {
  showLink: true,
  isVerticalItem: false
};